module.exports = __webpack_public_path__ + "img/img25.20dd3d87.png";